module.exports = __webpack_public_path__ + "static/media/12.51b769cc.jpg";